

import React, { useContext } from "react";
import { SearchContext } from "../../context/SearchContext";
import products from "../../data/product";
import ProductCard from "./ProductCard";

export default function ProductFilter() {
	const { search } = useContext(SearchContext);

	const filteredProducts = products.filter((product) =>
		product.name.tr.toLowerCase().includes(search.toLowerCase()) ||
		product.name.en.toLowerCase().includes(search.toLowerCase())
	);

	return (
		<div className="container my-4">
			<div className="row g-4">
				{filteredProducts.length > 0 ? (
					filteredProducts.map((product) => (
						<div
							key={product.id}
							className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex"
						>
							<ProductCard product={product} />
						</div>
					))
				) : (
					<div className="col-12">
						<div className="alert alert-danger">Ürün bulunamadı.</div>
					</div>
				)}
			</div>
		</div>
	);
}
